import React, { useEffect, useId, useRef } from 'react';
import { IconButton } from '../IconButton/IconButton.js';
const styles = {"dialog":"Dialog-module__dialog__CDqAl","content":"Dialog-module__content__EkF0y","form":"Dialog-module__form__PotTF","header":"Dialog-module__header__njOVt","title":"Dialog-module__title__4OS2G","description":"Dialog-module__description__-zZrd","body":"Dialog-module__body__iSVid","footer":"Dialog-module__footer__ns88M","footerStart":"Dialog-module__footerStart__xvuk1"};
// The content's first field takes focus on open; the browser alone would focus the close button, which comes first.
const FIRST_FIELD_SELECTOR = ['input', 'textarea', 'select'].map(field => `[data-dialog-body] ${field}:not([disabled])`).join(', ');
/**
 * A modal dialog (Trips board · G4): title and close button, content, footer. On a native `<dialog>`, so the browser
 * keeps focus inside and makes the page behind inert. On open the content's first field takes focus; on close focus
 * goes back to whatever had it when the dialog opened.
 */
export function Dialog({ title, open, onClose, closeLabel, presentation = 'auto', children, footer, footerStart, description, onSubmit }) {
    const dialogRef = useRef(null);
    const titleId = useId();
    const descriptionId = `${titleId}-description`;
    const hasDescription = description !== undefined && description !== '';
    useEffect(() => {
        const dialog = dialogRef.current;
        let closeAndRestoreFocus;
        if (open && dialog !== null) {
            const focusedBeforeOpening = document.activeElement;
            dialog.showModal();
            dialog.querySelector(FIRST_FIELD_SELECTOR)?.focus();
            closeAndRestoreFocus = () => {
                dialog.close();
                if (focusedBeforeOpening instanceof HTMLElement) {
                    focusedBeforeOpening.focus();
                }
            };
        }
        return closeAndRestoreFocus;
    }, [open]);
    // The browser would close the dialog itself on Esc; the owner closes it instead, by changing `open`.
    function handleCancel(event) {
        event.preventDefault();
        onClose();
    }
    // The content fills the dialog box, so a click whose target is the <dialog> itself landed on the backdrop.
    function handleClick(event) {
        if (event.target === event.currentTarget) {
            onClose();
        }
    }
    function handleSubmit(event) {
        event.preventDefault();
        onSubmit?.();
    }
    const bodyAndFooter = (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.body, "data-dialog-body": "" },
            hasDescription && React.createElement("p", { className: styles.description, id: descriptionId }, description),
            children),
        React.createElement("div", { className: styles.footer },
            footerStart !== undefined && React.createElement("div", { className: styles.footerStart }, footerStart),
            footer)));
    return (React.createElement("dialog", { ref: dialogRef, className: styles.dialog, "data-presentation": presentation, "aria-labelledby": titleId, "aria-describedby": hasDescription ? descriptionId : undefined, onCancel: handleCancel, onClick: handleClick },
        React.createElement("div", { className: styles.content },
            React.createElement("div", { className: styles.header },
                React.createElement("h2", { className: styles.title, id: titleId }, title),
                React.createElement(IconButton, { icon: "x", label: closeLabel, onClick: onClose })),
            onSubmit === undefined ? bodyAndFooter : React.createElement("form", { className: styles.form, onSubmit: handleSubmit }, bodyAndFooter))));
}
//# sourceMappingURL=Dialog.js.map